import React, { useEffect, useState } from "react";
import {
  getBegabungProjektePage,
  getEinblicke,
  BEGABUNG_PROJEKTE_CATEGORY,
} from "../lib/api";
import { Page, PageHeader, Section, SectionHead, PostFeed } from "../components/ui";

/**
 * The post grid, overlay and "Weiterlesen →" now come from the shared
 * PostFeed, which is a straight port of the Mitgestalten markup.
 *
 * `category` is the filter tag and `limit` caps how many cards show,
 * so the same component covers both pages:
 *   Mitgestalten   → category="Eltern",           no limit
 *   Begabung       → category="Begabungsförderung", limit={3}
 */
export default function BegabungProjektePage() {
  const [page, setPage] = useState(null);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    Promise.all([getBegabungProjektePage(), getEinblicke()])
      .then(([pageRes, entriesRes]) => {
        if (cancelled) return;
        setPage(pageRes);
        setEntries(entriesRes);
        setLoading(false);
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err);
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Page>
      <PageHeader
        parent={{ label: "Begabungsförderung", to: "/konzept-und-ziele" }}
        current="Projekte & Erfolge"
        title={page?.heroTitle || "Projekte & Erfolge"}
        subtitle={page?.heroSubtitle}
      />

      <Section>
        <SectionHead title={page?.sectionTitle} subtitle={page?.sectionSubtitle} />

        <PostFeed
          entries={entries}
          category={page?.carouselCategory || BEGABUNG_PROJEKTE_CATEGORY}
          limit={6}
          queryParam="projekt"
          loading={loading}
          error={error}
        />
      </Section>
    </Page>
  );
}